import { ButtonIcon } from 'component/ui/Button';
import styled from 'styled-components';

interface ShowHideButtonProps {
  $show?: boolean;
}

export const ShowHideButton = styled(ButtonIcon)<ShowHideButtonProps>``;
